module.exports = __webpack_public_path__ + "static/media/montagne.34ed7b4f.jpg";